/**
 * Opens the device's system notification settings for this app.
 *
 * The Together Android app is a Trusted Web Activity (Custom Tabs), not a WebView, so there is no JS
 * bridge to call into. Instead the native app (discovery-together-twa) registers the `togetherscheme://`
 * custom scheme and handles it in UrlHandlerActivity. Navigating to
 * `togetherscheme://notification-settings` launches the Android app-notification settings screen
 * (Settings.ACTION_APP_NOTIFICATION_SETTINGS), mirroring the existing `request-notifications` flow used
 * from KidsHome.
 *
 * We pass the current URL as `returnUrl` so that when the user backs out of the settings screen the native
 * app relaunches the TWA here with a fresh `notificationsEnabled` value — letting the banner update to
 * reflect whatever they just changed.
 */
export default function openDeviceNotificationSettings() {
  if (typeof window === 'undefined') return
  const returnUrl = encodeURIComponent(window.location.href)
  window.location.href = `togetherscheme://notification-settings?returnUrl=${returnUrl}`
}
